import { createContext, useContext } from 'react';

/**
 * Контекст блокировки экрана.
 * Провайдер — Layout.jsx (через useScreenLock).
 * Потребители — Header, ProfileDropdown и другие компоненты, которым нужно
 * знать, включена ли блокировка, чтобы показывать / скрывать кнопку «Заблокировать».
 */
export const ScreenLockContext = createContext({
  isEnabled: false,
  isLocked: false,
  serverConfig: null,
});

export const useScreenLockContext = () => useContext(ScreenLockContext);
